<ng-template *ngTemplateOutlet="siteClientLookup"></ng-template>
@if (searchPressed) {
  <div class="me-lg-2 my-2 text-end d-flex gap-1 justify-content-end">
    @if (
      totalJobCount >= 1 && (defaultJob ? totalJobCount != totalRows : true)
    ) {
      <button
        class="btn btn-sm"
        (click)="showAllJobsDesktop()"
        [ngClass]="defaultJob ? 'btn-outline-danger' : 'btn-danger'"
      >
        {{ defaultJob ? "All Status" : "Active Only" }}
      </button>
    }
    @if (totalJobCount > 5 && !largeView) {
      <button
        class="btn btn-secondary btn-sm"
        (click)="isSortPopupVisisble = !isSortPopupVisisble"
      >
        <i class="fa-solid fa-arrow-up-wide-short fa-lg"></i>
      </button>
    }
  </div>
  <div
    class="dropdown-menu shadow sort-popover-position"
    [ngClass]="{
      'd-none': !isSortPopupVisisble,
      'd-block': isSortPopupVisisble,
    }"
  >
    @for (item of sortItemList; track item) {
      <div class="row align-items-center p-2" (click)="sortField(item)">
        <button class="btn btn-outline-secondary w-100 text-start">
          {{ item.header }}
          <span class="float-end">
            @if (item?.sortOrder) {
              <span>
                <i class="fa fa-arrow-down"></i>
              </span>
            }
            @if (!item?.sortOrder) {
              <span>
                <i class="fa fa-arrow-up"></i>
              </span>
            }
          </span>
        </button>
      </div>
    }
  </div>

  <div class="pt-lg-3">
    @if (largeView) {
      <gtapp-gt-table
        [desktopTableBackendData]="listJobData"
        [desktopTableDetails]="jobDetailsTableView"
        [tableStyle]="tableStyle"
        [otherParams]="otherParams"
        (paginationChange)="onChangePagination($event)"
        (sortColumn)="sortColumn($event)"
        (searchColumn)="searchColumn($event)"
        (rowClick)="openIndividualJob($event)"
      >
      </gtapp-gt-table>
    } @else {
      <!-- <div class="my-2" *ngIf="totalJobCount > 5">
      <gtapp-auto-complete
        [data]="dropDownJobs"
        placeHolder="Search Jobs"
        searchKeyword="name"
        [initialValue]="globalFilter"
        [itemTemplate]="cpLookupTemplate"
        (inputChanged)="onFilterApply($event)"
        (selected)="openIndividualJob($event)"
        (submitted)="globalFilter = $event; onFilterApply($event)"
        >
      </gtapp-auto-complete>

      <ng-template #cpLookupTemplate let-item>
        <div>{{ item.job_key }} ({{ item.status }})</div>
        <div>{{ item?.site_name }} [{{ item?.company }}]</div>
      </ng-template>
    </div> -->
      <gtapp-infinite-list
        [mobileCardBackendData]="infiniteJobList"
        [mobileCardDetails]="jobCardsDetails"
        [otherParams]="otherParams"
        [totalRows]="totalRows"
        (loadMoreData)="loadMoreJobs()"
        (rowClick)="openIndividualJob($event)"
        (searchColumn)="searchColumn($event)"
        (sortColumn)="sortColumn($event)"
      ></gtapp-infinite-list>
    }
  </div>
}
<ng-template #siteClientLookup let-siteClientLookupTempRef="dialogRef">
  <div class="d-flex flex-wrap gap-2 my-2 flex-column flex-lg-row">
    <div class="px-2">
      <div class="form-floating">
        <input
          class="form-control"
          placeholder="Pick Date Range"
          readonly
          [value]="dateRangeValue"
          (click)="openRangePicker()"
        />
        <label>Pick Date Range</label>
      </div>
    </div>
    <div class="d-flex align-items-center px-2">
      @if (siteClientLookupData?.site?.data?.id) {
        <div class="d-flex align-items-center">
          <div>
            <div class="flex-grow-1">
              <dt class="d-none">Site</dt>
              <dd class="fs-6">
                {{ siteClientLookupData?.site?.value }}
                @if (siteClientLookupData?.site?.data?.company?.company_name) {
                  <span>
                    [{{
                      siteClientLookupData?.site?.data?.company?.company_name
                    }}]
                  </span>
                }
                <span
                  class="ms-3 edit-button"
                  (click)="editField('site')"
                ></span>
              </dd>
            </div>
          </div>
        </div>
      }
      @if (!siteClientLookupData?.site?.data?.id) {
        <div
          [ngClass]="siteClientLookupData?.site?.disabled ? 'opacity-50' : ''"
        >
          @if (!siteClientLookupData?.site?.hide) {
            <gtapp-auto-complete
              [data]="siteListData"
              placeHolder="Select Site"
              searchKeyword="company_name"
              [initialValue]="siteClientLookupData?.site?.value"
              [itemTemplate]="siteTemplate"
              (inputChanged)="onSiteSearch($event)"
              (selected)="onSelectSite($event)"
              inputId="siteId"
              [enableCloseOption]="true"
              (fieldCleared)="editField('site')"
              (inputFocused)="inputFocused('site')"
            >
            </gtapp-auto-complete>
          }
          <ng-template #siteTemplate let-item>
            @if (item?.key === 0) {
              <div>Create New Site</div>
            } @else {
              <div>
                <div class="fw-medium">
                  {{ item?.company_name }} [{{ item?.company?.company_name }}]
                </div>
                <div class="small-font text-secondary">
                  {{ item?.address?.full_address }}
                </div>
              </div>
            }
          </ng-template>
        </div>
      }
    </div>
    <div class="d-flex align-items-center px-2">
      @if (siteClientLookupData?.client?.data?.id) {
        <div>
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <dt class="d-none">Client</dt>
              <dd class="fs-6">
                {{ siteClientLookupData?.client?.value }}
                <span
                  class="ms-3 edit-button"
                  (click)="editField('client')"
                ></span>
              </dd>
            </div>
          </div>
        </div>
      }
      @if (!siteClientLookupData?.client?.data?.id) {
        <div
          [ngClass]="siteClientLookupData?.client?.disabled ? 'opacity-50' : ''"
        >
          @if (!siteClientLookupData?.client?.hide) {
            <gtapp-auto-complete
              [data]="clientDropDownList"
              placeHolder="Select Client"
              searchKeyword="company_name"
              [itemTemplate]="clientLookupTemplate"
              (inputChanged)="onClientSearch($event)"
              [initialValue]="siteClientLookupData?.client?.value"
              (selected)="onClientSelect($event)"
              [enableCloseOption]="true"
              inputId="clientLookupId"
              (fieldCleared)="editField('client')"
              (inputFocused)="inputFocused('client')"
            >
            </gtapp-auto-complete>
          }
          <ng-template #clientLookupTemplate let-item>
            <div>
              {{ item?.company_name }}
            </div>
          </ng-template>
        </div>
      }
    </div>
    <div class="px-2">
      <button class="btn btn-primary btn-lg px-5" (click)="searchData()">
        Search
      </button>
    </div>
  </div>
</ng-template>
